import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { IPublishButtonProps } from '../containers/PublishButton.container';

interface IPublishButtonOwnProps extends IPublishButtonProps {
  className?: string;
  projectId?: string;
}

export const PublishButton = observer((props: IPublishButtonOwnProps): ReactElement => {
  const { t } = useTranslator();
  const loaderKey = 'publish-button-loader';
  return (
    <ButtonWithLoader
      onClick={props.onClick}
      loaderKey={props.projectId ? `${loaderKey}-${props.projectId}` : loaderKey}
      disabled={props.disabled}
      className={props.className}
      title={t('publish')}
    >
      {t('publish')}
    </ButtonWithLoader>
  );
});
